<template>
  <div
    class="mx-0 pb-[40px] mb-5 w-full bg-white relative md:rounded md:shadow-lg md:mx-auto max-w-[784px]"
    data-tooltip-wrapper
  >
    <div v-if="step.isLoading || step.isMasked" class="w-full h-full absolute bg-curtain-color z-[100]">
      <DotLottieVue
        v-if="step.isLoading"
        autoplay
        class="absolute top-[50%] left-[50%] translate-y-[-50%] translate-x-[-50%]"
        style="width: 50px; height: 50px"
        loop
        :data="loadingIconData"
      />
    </div>
    <slot name="header">
      <div>
        <FormHeader :step="step" :stepIndex="stepIndex || 0" />
      </div>
    </slot>

    <!-- Default form content slot -->
    <div class="max-w-[100vw] pt-6 px-4 md:pt-8 md:px-10">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import FormHeader from '@/components/FormHeader/FormHeader.vue';
import { IFormStep } from '@/interfaces';
import loadingData from '@/assets/animated-icons/Loading_spinner_blue.json';
import { DotLottieVue } from '@lottiefiles/dotlottie-vue';
import { watch } from 'vue';
import { useFormStore } from '@/store';

const loadingIconData = loadingData as any;

// Define props and state
// ------------------------------------------------------------- //
const props = defineProps<{
  step: IFormStep;
  stepIndex?: number;
}>();

const formStore = useFormStore();

watch(
  () => props.step.isActive,
  async (newValue) => {
    if (newValue) {
      formStore.focusFirstTabbableAfterRender();
    }
  }
);
</script>
